
function getScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

const scrollbarWidth = getScrollbarWidth()

function freezeScroll() {
    setTimeout(() => {
        document.body.style.overflow = 'hidden'

        if (document.body.scrollHeight > window.innerHeight) {
            document.body.style.paddingRight = `${scrollbarWidth}px`
        }
    }, 1);
}

function unfreezeScroll() {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
}

function showOverlay(time = 250, allowScroll = false) {
    setTimeout(() => {
        $('.c-overlay').addClass('is-active');

        if (!allowScroll) {
            $('body').addClass('is-overlayed');

            freezeScroll();
        }
    }, 1);
}

function hideOverlay(time = 250) {
    unfreezeScroll();

    setTimeout(() => {
        $('.c-overlay').removeClass('is-active');
        $('body').removeClass('is-overlayed');
    }, 0);
}